import script from "./buildInfo.vue?vue&type=script&lang=js"
export * from "./buildInfo.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__